import React from 'react';
import PropTypes from 'prop-types';

ShowMoreButton.propTypes = {
  count: PropTypes.number,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  noun: PropTypes.string,
  progressive: PropTypes.bool
};

export default function ShowMoreButton({ count, onClick, disabled, noun = 'items', progressive = true }) {
  if (!count || count <= 0) return null;
  return (
    <button className="btn btn-secondary" onClick={onClick} disabled={disabled} aria-live="polite">
      {progressive && <span>Show more {noun} ({count} remaining)</span>}
      {!progressive && <span>Show {count} more {noun}</span>}
    </button>
  );
}


